angular.module('tradersyard').controller('whitelist-widget-ctrl', [
    '$scope',
    '$timeout',
    'graph-whitelist-factory',
    'graph-search-factory',
    function ($scope, $timeout, $api, $search) {
        $scope.Page = 0;
        $scope.Data = [];
        $scope.Find = [];
        $scope.Word = '';
        $scope.Mode = 'query';

        function Query(next) {
            $api.query({ params: { page: ++$scope.Page } }).then(function (response) {
                if (response.data.state === 0) {
                    $scope.Data = $scope.Data.concat(response.data.data);

                    if (next) {
                        next();
                    }
                }
            });
        }

        function Insert(node) {
            $api.entry(undefined, node.id)
                .insert()
                .then(function (response) {
                    if (response.data.state === 0) {
                        node.in_whitelist = true;
                        $scope.Data.unshift(node);
                    }
                });
        }

        function Delete(node) {
            $api.entry(undefined, node.id)
                .delete()
                .then(function (response) {
                    if (response.data.state === 0) {
                        $scope.Data.forEach(function ($node, index) {
                            if ($node.id === node.id) {
                                $scope.Data.splice(index, 1);
                            }
                        });

                        $scope.Find.forEach(function ($node, index) {
                            if ($node.id === node.id) {
                                $node.in_whitelist = false;
                            }
                        });
                    }
                });
        }

        $scope.searchPage = 0;
        $scope.SearchLock = 0;

        function SearchPaging(next) {
            $scope.SearchLock = 1;

            $search
                .entry('whitelist')
                .search({
                    params: {
                        page: ++$scope.searchPage,
                        q: $scope.Word,
                    },
                })
                .then(function (response) {
                    $scope.SearchLock = 0;

                    if (response.data.state === 0) {
                        if ($scope.searchPage === 1) {
                            $scope.Find = response.data.data;
                        } else {
                            $scope.Find = $scope.Find.concat(response.data.data);
                        }

                        if (next) {
                            next();
                        }
                    }
                });
        }

        function SearchChange() {
            $scope.searchPage = 0;
            $scope.Find = [];
            SearchPaging();
        }

        Query();

        var t;

        $scope.$watch(
            function () {
                return $scope.Word;
            },
            function (val, $nval) {
                if (val !== $nval) {
                    if (t) $timeout.cancel(t);

                    $scope.SearchLock = 1;
                    t = $timeout(function () {
                        $scope.searchPage = 0;
                        $scope.Find = [];
                        SearchPaging();
                    }, 0);
                }
            }
        );

        angular.extend($scope, {
            Query: Query,
            Insert: Insert,
            Delete: Delete,
            SearchPaging: SearchPaging,
            SearchChange: SearchChange,
        });
    },
]);
